window.addEventListener('DOMContentLoaded', initializeHeaderToggle);

function initializeHeaderToggle() {
  const header = document.querySelector('#header');

  if (header) {
    handleMenu(header);
  }
}

function handleMenu(header) {
  const menuToggle = header.querySelector('#menu-toggle');
  const menu = header.querySelector('#primary-navigation');

  if (menuToggle && menu) {
    menuToggle.addEventListener('click', () => {
      const expanded = menuToggle.getAttribute('aria-expanded') === 'true';

      menuToggle.setAttribute('aria-expanded', !expanded);
      menu.setAttribute('aria-expanded', !expanded);
      header.setAttribute('menu-out', !expanded);
    });

    menu.addEventListener('click', (e) => {
      if (e.target.id === 'primary-navigation') {
        menuToggle.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-expanded', 'false');
        header.setAttribute('menu-out', 'false');
      }
    });
  }
}
